import { render } from "./DTHistory.vue?vue&type=template&id=61d370a6"
import script from "./DTHistory.vue?vue&type=script&lang=js"
export * from "./DTHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__